/* Dollar currencies other than USD (CAD, AUD, NZD, SGD, HKD...) print as a bare "$" with Shopify's default formats.
   Prefix the price texts with the country symbol (CA$, A$...) so shoppers never mistake them for US dollars.
   Only text inside price elements is touched; the store currency (USD) and non-dollar currencies are left alone. */
(function () {
  var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
  var PFX = { CAD: 'CA$', AUD: 'A$', NZD: 'NZ$', SGD: 'S$', HKD: 'HK$', TWD: 'NT$', MXN: 'MX$', BSD: 'B$', BBD: 'Bds$', JMD: 'J$', TTD: 'TT$', FJD: 'FJ$', XCD: 'EC$', BZD: 'BZ$', BMD: 'BD$', KYD: 'CI$', LRD: 'L$', SBD: 'SI$', GYD: 'G$', SRD: 'Sr$', BND: 'B$', NAD: 'N$' };
  if (!cur || !PFX[cur]) return;
  var pfx = PFX[cur], SEL = '[class*="price"],[class*="money"],[class*="amount"],[class*="total"],[class*="subtotal"],[class*="cgc-fee-line__p"],[class*="cgc-sr-item__p"]';
  var re = /(^|[^A-Za-z$])\$(?=\s?\d)/g;
  function fix(root) {
    var els = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    var list = Array.prototype.slice.call(els);
    if (root.matches && root.matches(SEL)) list.push(root);
    list.forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('$') > -1 && n.nodeValue.indexOf(pfx) < 0 && n.nodeValue.indexOf(cur) < 0) n.nodeValue = n.nodeValue.replace(re, '$1' + pfx); }
    });
  }
  function start() {
    fix(document.body);
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1) fix(x); else if (x.nodeType === 3 && x.parentElement) fix(x.parentElement); }); if (m.type === 'characterData' && m.target.parentElement) fix(m.target.parentElement); }); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
